/* Нижняя панель навигации (mobile/tablet).
   Вынесено из inline <script> секции mobile-bar: ~6,9 KB на каждой
   странице сайта. Селектор `.section-<id>-settings` заменён на `.mobile-bar` —
   тот же элемент, но без Liquid-подстановки. */
(function() {
    const chatToggle = document.querySelector('.mobile-bar__chat-toggle');
    const chatMenu = document.getElementById('mobile-bar-chat-menu');
    const chatOverlay = document.getElementById('mobile-bar-chat-overlay');
    const inboxBtn = document.querySelector('.mobile-bar__chat-inbox');
    const waOption = document.querySelector('.mobile-bar__chat-wa');
    const orderStatusOption = document.querySelector('.mobile-bar__chat-order-status');
    const mobileBar = document.querySelector('.mobile-bar');
    const otherMobileBarItems = document.querySelectorAll(
      '.mobile-bar__menu button, .mobile-bar__home a, .mobile-bar__accaunt a, .mobile-bar__cart a'
    );

    function updateMobileBarHeight() {
      if (!mobileBar) return;

      const height = mobileBar.offsetHeight || 70;
      document.documentElement.style.setProperty('--mobile-bar-height', height + 'px');
    }

    function openChatMenu() {
      if (!chatToggle || !chatMenu) return;

      updateMobileBarHeight();
      chatToggle.setAttribute('aria-expanded', 'true');
      chatMenu.classList.remove('hidden');
      if (chatOverlay) chatOverlay.classList.remove('hidden');
    }

    function closeChatMenu() {
      if (!chatToggle || !chatMenu) return;

      chatToggle.setAttribute('aria-expanded', 'false');
      chatMenu.classList.add('hidden');
      if (chatOverlay) chatOverlay.classList.add('hidden');
    }

    let maxViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

    function isKeyboardInput(element) {
      if (!element) return false;

      const tagName = element.tagName ? element.tagName.toLowerCase() : '';
      return (
        tagName === 'input' ||
        tagName === 'textarea' ||
        tagName === 'select' ||
        element.isContentEditable
      );
    }

    function updateKeyboardState() {
      updateMobileBarHeight();

      const currentViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

      if (!isKeyboardInput(document.activeElement)) {
        maxViewportHeight = Math.max(maxViewportHeight, currentViewportHeight);
        document.body.classList.remove('mobile-bar-keyboard-open');
        return;
      }

      const keyboardIsOpen = maxViewportHeight - currentViewportHeight > 80;

      document.body.classList.toggle('mobile-bar-keyboard-open', keyboardIsOpen);

      if (keyboardIsOpen) {
        closeChatMenu();
      }
    }

    updateMobileBarHeight();
    updateKeyboardState();

    // The bar's real height can change across breakpoints (e.g. icon/label
    // sizing) or on orientation change, so keep --mobile-bar-height fresh
    // instead of freezing it at whatever was measured on initial load —
    // other floating elements (cart panel, back-to-top) rely on this value
    // to clear the bar correctly at every width.
    window.addEventListener('resize', updateMobileBarHeight);
    window.addEventListener('load', updateMobileBarHeight);

    window.addEventListener('resize', updateKeyboardState);
    window.addEventListener('orientationchange', function() {
      maxViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      updateKeyboardState();
    });

    document.addEventListener('focusin', function() {
      setTimeout(updateKeyboardState, 80);
    });

    document.addEventListener('focusout', function() {
      setTimeout(updateKeyboardState, 180);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateKeyboardState);
      window.visualViewport.addEventListener('scroll', updateKeyboardState);
    }

    if (chatToggle && chatMenu) {
      chatToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = chatToggle.getAttribute('aria-expanded') === 'true';
        isExpanded ? closeChatMenu() : openChatMenu();
      });

      otherMobileBarItems.forEach(function(item) {
        item.addEventListener('click', function() {
          closeChatMenu();
        });
      });

      // Open WhatsApp popup on click
      if (waOption) {
        waOption.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeChatMenu();

          if (typeof window.waOpenModal === 'function') {
            window.waOpenModal();
          }
        });
      }

      // Open Order Status modal on click
      if (orderStatusOption) {
        orderStatusOption.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeChatMenu();

          if (typeof window.osOpenModal === 'function') {
            window.osOpenModal();
          }
        });
      }

      // Open Shopify Inbox on click.
      // The widget host is <shopify-chat>. It first renders button.activator in its
      // own shadow root, then hydrates into <shopify-agent-runtime>, which holds a
      // SECOND, nested shadow root. Both stages must be handled. The button also
      // responds to a programmatic .click() while hidden (mobile), which is how the
      // panel opens even though the floating launcher is hidden there.
      if (inboxBtn) {
        var findActivator = function() {
          var host = document.querySelector('shopify-chat');
          if (!host || !host.shadowRoot) return null;

          var btn = host.shadowRoot.querySelector('button.activator');
          if (btn) return btn;

          var runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
          if (runtime && runtime.shadowRoot) {
            return runtime.shadowRoot.querySelector('button.activator');
          }
          return null;
        };

        inboxBtn.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeChatMenu();

          var button = findActivator();
          if (button) {
            button.click();
            return false;
          }

          // Widget script not finished loading yet: poll briefly, then give up.
          var tries = 0;
          var iv = setInterval(function() {
            tries++;
            var b = findActivator();
            if (b) {
              clearInterval(iv);
              b.click();
            } else if (tries > 50) {
              clearInterval(iv);
            }
          }, 100);

          return false;
        };
      }
      // Close menu when clicking on overlay or outside
      if (chatOverlay) {
        chatOverlay.addEventListener('click', function() {
          closeChatMenu();
        });
      }

      document.addEventListener('click', function(e) {
        if (!e.target.closest('.mobile-bar__chat-wrapper') && !e.target.closest('#mobile-bar-chat-menu')) {
          closeChatMenu();
        }
      });
    }
  })();
